import * as React from "react";
import type { SVGProps } from "react";
const SvgUserList = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.5 9.5a4.5 4.5 0 1 1 7.535 3.323A6 6 0 0 1 14 18v1h-2v-1a4 4 0 0 0-8 0v1H2v-1a6 6 0 0 1 2.966-5.177A4.49 4.49 0 0 1 3.5 9.5M8 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20.5 11.5c0 .866-.314 1.658-.835 2.269A5 5 0 0 1 22 18v1h-2v-1a3 3 0 0 0-3-3 3.5 3.5 0 1 1 3.5-3.5M17 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgUserList;
